import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';

const templateUrl = require('./userDetail.html');

class UserDetailController extends ComponentController {
  user: any;
  canDelete: boolean;
  canEditRoles: boolean;

  constructor(
    private $state: any,
    private UserService: any,
    private AuthService: any,
    private Notify: any,
    private uibModal: any
  ) {
    super();
  }

  $onInit = () => {
    this.canEditRoles = this.user.id && this.AuthService.hasPermission('UserRoles', 'create');
    this.canDelete = this.user.id && this.AuthService.hasPermission('User', 'delete');
  };

  saveUser = () => {
    if (this.user.password == this.user.passwordConfirmation) {
      this.UserService.save(this.user).then(response => {
        this.Notify.success(`User ${this.user.firstName} ${this.user.lastName} successfully saved`);
        if (this.user.id) {
          this.goToUsers();
        } else {
          this.Notify.success(
            `Users must confirm their email address. Check ${this.user
              .email} for confirmation instructions`
          );
          this.$state.go('admin.user-detail', { userId: response.id });
        }
      });
    } else {
      alert('password confirmation must match password');
    }
  };

  deleteResource = () => {
    this.UserService.delete(this.user).then(() => {
      this.goToUsers();
    });
  };

  goToUsers = () => {
    this.$state.go('admin.users');
  };

  goToUserRole($event, userRoleId) {
    this.stopProp($event);
    this.$state.go('admin.user-role', { userRoleId: userRoleId });
  }

  confirmDelete = () => {
    this._confirmDelete(this.uibModal, this.user, this.user.name);
  };
}

angular.module('ciApp').component('userDetail', {
  templateUrl: templateUrl,
  bindings: {
    user: '<'
  },
  controller: ['$state', 'UserService', 'AuthService', 'Notify', '$uibModal', UserDetailController]
});



// WEBPACK FOOTER //
// ./app/admin/users/userDetail.component.ts